import React, { useEffect, useState } from "react";
import _ from "lodash";

import { Form, Input, Button, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

export const InputMultipleText = (props) => {
  const { item, form } = props;

  function onChange(valueId, index) {
    const allValues = form.getFieldsValue()?.[item?.id] || [];
    item['value'] = allValues;
  }

  return (
    <Form.List name={item?.id}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, fieldKey, ...restField }) => (
            <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
              <Form.Item
                {...restField}
                name={[name, 'shirtNumber']}
                fieldKey={[fieldKey, 'number']}
                rules={[{ required: true, message: 'Missing number' }]}
                onChange={onChange}
              >
                <Input placeholder="Number" type="number" />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[name, 'label']}
                fieldKey={[fieldKey, 'name']}
                rules={[{ required: true, message: 'Missing name' }]}
                onChange={onChange}
              >
                <Input placeholder="Name" />
              </Form.Item>
              <MinusCircleOutlined onClick={() => remove(name)} />
            </Space>
          ))}
          <Form.Item>
            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ width: 200 }}>
              Add Player
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};
